import { apportionmentFields } from '../../definitions/constants';

export const PARENT = apportionmentFields.parentObject;

export const FIELDS = {
  veteranIncarceratedOver60Days: 'veteranIncarceratedOver60Days',
  veteranIncarcerationFelonyOrMisdemeanor:
    'veteranIncarcerationFelonyOrMisdemeanor',
  veteranIncarcerationFacilityName: 'veteranIncarcerationFacilityName',
  veteranIncarcerationFacilityAddress: 'veteranIncarcerationFacilityAddress',

  survivingBeneficiaryIncarceratedOver60Days:
    'survivingBeneficiaryIncarceratedOver60Days',
  survivingBeneficiaryIncarcerationFelonyOrMisdemeanor:
    'survivingBeneficiaryIncarcerationFelonyOrMisdemeanor',
  survivingBeneficiaryFacilityName: 'survivingBeneficiaryFacilityName',
  survivingBeneficiaryFacilityAddress: 'survivingBeneficiaryFacilityAddress',

  veteranIncompetentInCare: 'veteranIncompetentInCare',
  veteranCompetenceFacilityName: 'veteranCompetenceFacilityName',
  veteranCompetenceFacilityAddress: 'veteranCompetenceFacilityAddress',

  veteranReceivingPensionInCare: 'veteranReceivingPensionInCare',
  veteranPensionFacilityName: 'veteranPensionFacilityName',
  veteranPensionFacilityAddress: 'veteranPensionFacilityAddress',

  beneficiaryInEnemyTerritory: 'beneficiaryInEnemyTerritory',

  veteranDisappeared: 'veteranDisappeared',
};

export const YES = 'yes';
export const NO = 'no';

export const YES_NO = [YES, NO];
export const CONVICTION_TYPE = ['felony', 'misdemeanor'];

export const REASON_ANSWER_FIELDS = [
  FIELDS.veteranIncarceratedOver60Days,
  FIELDS.survivingBeneficiaryIncarceratedOver60Days,
  FIELDS.veteranIncompetentInCare,
  FIELDS.veteranReceivingPensionInCare,
  FIELDS.beneficiaryInEnemyTerritory,
  FIELDS.veteranDisappeared,
];

export const getApportionmentData = formData => formData?.[PARENT] || {};

export const getField = (formData, field) =>
  getApportionmentData(formData)?.[field];

export const isYes = (formData, field) => getField(formData, field) === YES;

export const hasValue = (formData, field) => !!getField(formData, field);

export const allAnswersNo = formData => {
  const apportionmentData = getApportionmentData(formData);
  return REASON_ANSWER_FIELDS.every(field => apportionmentData[field] === NO);
};

export const noPriorAnswerYes = (formData, priorFields) =>
  !priorFields.some(field => isYes(formData, field));

export const isBlank = value =>
  value === undefined || value === null || String(value).trim() === '';

export const validateRequiredWhen =
  (predicate, message) => (errors, value, formData) => {
    if (predicate(formData) && isBlank(value)) {
      errors.addError(message);
    }
  };

export const buildReasonPageDescriptionUI = (fieldName, description) => ({
  [fieldName]: {
    'ui:field': 'ViewField',
    'ui:description': description,
  },
});

export const buildReasonPageDescriptionSchema = fieldName => ({
  [fieldName]: {
    type: 'object',
    properties: {},
  },
});
